// extracted by mini-css-extract-plugin
export default {"iframeContainer":"ProductCourse_iframeContainer__YYwNF","productContainer":"ProductCourse_productContainer__KXZof"};